import { IconButton } from '@chakra-ui/react'
import React from 'react'
import { X } from 'react-feather'

interface CloseButtonProps {
  onClick: () => void
}

export const CloseButton = ({ onClick }: CloseButtonProps): JSX.Element => (
  <IconButton
    aria-label="close"
    variant="outlineRoundedFull"
    flexShrink={0}
    icon={<X size={20} />}
    onClick={onClick}
  />
)
